import React from 'react';

const UsingMinute7WithoutQB = () => (
    <div>
        <div className="sectionQuestion">Using Minute7 Without QuickBooks?</div>
        <div className="sectionAnswer">
            <div>
                While Minute7 offers seamless QuickBooks integration, you don't need QuickBooks to
                use our platform.
            </div>
            <div>
                Minute7 works perfectly as a standalone time and expense tracking system. All data
                can be entered, managed, and reported directly within Minute7—no accounting software
                required.
            </div>
        </div>
    </div>
);
export default UsingMinute7WithoutQB;
